import { render, staticRenderFns } from "./App.vue?vue&type=template&id=d3ba14aa&"
import script from "LS/components/app.component?vue&type=script&lang=js&"
export * from "LS/components/app.component?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports